/* eslint-disable no-console */
import mixpanel from 'mixpanel-browser';

/** Track a custom action/event. */
export const trackAction = (actionName, context) => {
  try {
    if (context !== undefined) {
      mixpanel.track(actionName, context);
    } else {
      mixpanel.track(actionName);
    }
  } catch (error) {
    console.error(`Error tracking Mixpanel event "${actionName}":`, error);
  }
};

/** Register a single super property sent with every subsequent event. */
export const setGlobalContextProperty = (key, value) => {
  try {
    mixpanel.register({ [key]: value });
  } catch (error) {
    console.error(`Error setting Mixpanel context property "${key}":`, error);
  }
};

/** Remove a previously registered super property. */
export const removeGlobalContextProperty = (key) => {
  try {
    mixpanel.unregister(key);
  } catch (error) {
    console.error(`Error removing Mixpanel context property "${key}":`, error);
  }
};

/** Track a page view (used on SPA route changes). */
export const trackPageView = (pageName, properties) => {
  try {
    const page = typeof pageName === 'string' ? pageName.replace(/^\/+|\/+$/g, '') : pageName;
    mixpanel.track_pageview({ page, ...properties });
  } catch (error) {
    console.error('Error tracking Mixpanel page view:', error);
  }
};



// WEBPACK FOOTER //
// ./utils/mixpanelUtils.js